export const projects = [
  {
    id: "ontrack",
    name: "Ontrack",
    date: "March 2024",
    description:
      "A robust and responsive web application to manage your job applications.",
    stack: ["React", "Firebase", "Material UI", "Playwright"],
    features: [
      "Create, edit, and delete applications",
      "Option to filter applications",
      "Dark mode toggle",
    ],
    link: "https://job-tracker-app-delta.vercel.app/",
    repo: "https://github.com/trinhbond/job-tracker-app",
    images: [
      "../assets/images/job-tracker-home.png",
      "../assets/images/job-tracker-1.png",
      "../assets/images/job-tracker-2.png",
      "../assets/images/job-tracker-3.png",
      "../assets/images/job-tracker-4.png",
    ],
  },
];
